import { render, staticRenderFns } from "./StatisticsGeneral.vue?vue&type=template&id=5320a80e"
import script from "./StatisticsGeneral.vue?vue&type=script&lang=js"
export * from "./StatisticsGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports